module.exports = __webpack_public_path__ + "static/media/AWS_firstPage_ko.9036075c.png";